import { PricePackage as PricePackageProps } from './pricepackages';
import Meta from 'antd/lib/card/Meta';
import styles from './styles.module.css';
import { Button, Card, Col, Divider, Row } from 'antd';
import { useIntl, FormattedMessage } from 'react-intl';

export type Currency = 'euro' | 'dollar';

const PricePackage = ({
  pricePackage: { title, name, subTitle, description1, description2, price },
  currency,
  onFreeTrailActionClick,
}: {
  pricePackage: PricePackageProps;
  currency: Currency;
  onFreeTrailActionClick?: () => void;
}): JSX.Element => {
  const { formatMessage } = useIntl();

  return (
    <Card bordered>
      <Meta
        style={{ minHeight: 60 }}
        title={
          title
            ? formatMessage(title, {
                annually: price && price[currency].monthly,
                currency: currency === 'euro' ? '€' : '$',
                cent: price && price[currency].cent,
              })
            : undefined
        }
        description={subTitle ? formatMessage(subTitle) : undefined}
      />
      <Divider />
      <Row className={styles.priceCardContent} gutter={[32, 32]}>
        <Col span={24}>
          <h2>{name ? formatMessage(name) : undefined}</h2>
          {description1
            ? formatMessage(description1, {
                annually: price && price[currency].monthly,
                cent: price && price[currency].cent,
                currency: currency === 'euro' ? '€' : '$',
              })
            : undefined}
          <br />
          <br />
          {description2
            ? formatMessage(description2, {
                cent: price && price[currency].cent,
                currency: currency === 'euro' ? '€' : '$',
              })
            : undefined}
        </Col>
      </Row>
      <Divider />
      {onFreeTrailActionClick ? (
        <Col span={24}>
          <Button type="primary" size="large" onClick={onFreeTrailActionClick}>
            <FormattedMessage
              defaultMessage="Try free"
              description="homepage/custom-integrations/free/link"
            />
          </Button>
        </Col>
      ) : undefined}
      <Col span={24}>
        <FormattedMessage
          defaultMessage="You have one month to check out if this is helping you to save time."
          description="off-the-shelve/pricing/free/description"
        />
      </Col>
    </Card>
  );
};
export default PricePackage;
